import { useDebouncedValue } from '@/hooks/useDebouncedValue'
import { PrepackCard } from './PrepackCard'
import PrepackAppearanceControls from './PrepackAppearanceControls'
import PrepackCopyFields from './PrepackCopyFields'
import PrepackTemplatePicker from './PrepackTemplatePicker'
import { useLivePack, usePrepackCopy } from './prepackCopyStore'

// The builder's subscribers to its copy store (see prepackCopyStore.js): the
// only components a title or tagline keystroke re-renders.

// Long enough to span the gap between keystrokes while typing a title.
const TILE_PACK_DELAY_MS = 300

export function LiveCopyFields({ store, ...props }) {
  const { title, titleSource, subtitle, subtitleSource } = usePrepackCopy(store)
  return (
    <PrepackCopyFields
      {...props}
      title={title}
      titleSource={titleSource}
      onTitleChange={(value, source) => store.set({ title: value, titleSource: source })}
      tagline={subtitle}
      taglineSource={subtitleSource}
      onTaglineChange={(value, source) => store.set({ subtitle: value, subtitleSource: source })}
    />
  )
}

export function LivePrepackCard({ store, pack, defaultTitle, ...props }) {
  const livePack = useLivePack(store, pack, defaultTitle)
  return livePack ? <PrepackCard {...props} pack={livePack} /> : null
}

// One card per template, each rebuilding and patching its artwork frame. The
// tiles follow the pack once it stops changing, so typing a title or dragging
// a colour only updates the live preview on every change. (useDeferredValue
// isn't enough: an idle page still commits every tile right after each key.)
export function LiveTemplatePicker({ store, pack, defaultTitle, ...props }) {
  const livePack = useLivePack(store, pack, defaultTitle)
  const tilePack = useDebouncedValue(livePack, TILE_PACK_DELAY_MS)
  return <PrepackTemplatePicker {...props} pack={tilePack} />
}

// Restyling sends the title, and a title edit discards a pending proposal.
export function LiveAppearanceControls({ store, pack, fallbackPack, defaultTitle, ...props }) {
  const livePack = useLivePack(store, pack, defaultTitle)
  return <PrepackAppearanceControls {...props} pack={livePack || fallbackPack} />
}
